import React from "react";
import DotPattern from "./DotPattern";

interface EmptyStateProps {
  message: string;
}

// `h-full` lets the message center when a parent gives the panel a height
// (the dashboard side panels wrap it in `flex-1 min-h-0`). `min-h-[16rem]` is
// the floor for parents that don't — the standalone Documents/Interactions
// tabs render the body in an auto-height block, where `h-full` alone collapses
// to zero and the message would be invisible.
const EmptyState: React.FC<EmptyStateProps> = ({ message }) => (
  <div className="relative h-full w-full min-h-[16rem] overflow-hidden">
    <DotPattern className="absolute inset-0 pointer-events-none" />
    <div className="absolute inset-0 flex items-center justify-center px-6">
      <div className="relative backdrop-blur-sm bg-white/50 px-6 py-3 rounded-2xl">
        <p className="text-lg font-medium text-gray-500 max-w-[320px] text-center leading-snug tracking-tight">
          {message}
        </p>
      </div>
    </div>
  </div>
);

export default EmptyState;
